export default __webpack_public_path__ + "static/media/1082.ff9c3a91.png";